import { financialValue } from '../../services/textService';

export const screenReaderPointDescriptorFactory = (decimalCount) => (point) => {
  const processedDescription = point.accessibility.description.replace("'", '');
  const processedValue = financialValue(point.y, {
    formatForScreenReader: true,
    decimalCount,
  });
  return `${processedDescription} ${processedValue}`;
};
